export default __webpack_public_path__ + "static/media/confrence-white.52cb220d.svg";